import { getParameterFromURL } from './getParameterFromUrl';
import saveABTestValue from './saveABTestValue';

const AB_TEST_KEY = 'p20v1_paywall_2paymentBlocks';

let isEnabledCache: boolean | null = null;

/**
 * Single source of truth for the "2 payment blocks" paywall variant.
 *
 * - `?p20v1Paywall2paymentBlocks=true` enables the new paywall.
 * - If `?nonUS=true` is also set, the 50/50 AB test `p20v1_paywall_2paymentBlocks`
 *   decides instead: variant B → new paywall, variant A → old one.
 * - Any other `nonUS` value (absent/false) doesn't affect the param behavior.
 *
 * Lazy + memoized: the AB test is assigned (and tracked) only on the first call,
 * which happens during render — after analytics are initialized.
 */
export const isTwoPaymentBlocksPaywallEnabled = (): boolean => {
  if (isEnabledCache !== null) {
    return isEnabledCache;
  }

  const enabledByParam = getParameterFromURL('p20v1Paywall2paymentBlocks') === 'true';
  const nonUS = getParameterFromURL('nonUS') === 'true';

  if (!enabledByParam) {
    isEnabledCache = false;
  } else if (!nonUS) {
    isEnabledCache = true;
  } else {
    isEnabledCache = saveABTestValue(2, AB_TEST_KEY, 'A', 'B', 50, 50) === `${AB_TEST_KEY}_B`;
  }

  return isEnabledCache;
};
